<svg width="7vh" height="7vh" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.257324" y="1" width="1" height="11" transform="rotate(-45 0.257324 1)" fill="#2400FF"/>
<rect x="23.7781" width="1" height="11" transform="rotate(45 23.7781 0)" fill="#2400FF"/>
<rect width="0.96883" height="10.6571" transform="matrix(0.729857 0.6836 0.729857 -0.6836 0 23.2852)" fill="#2400FF"/>
<rect width="0.96883" height="10.343" transform="matrix(0.729857 -0.6836 -0.729857 -0.6836 23.5488 23.7328)" fill="#2400FF"/>
</svg>
